// index.tsx
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { PageProps } from '../../../../types/navigationProperties';
import { Box } from '@mui/material';
import Footer from '../../../../components/Footer';
import MasonryImageList from '../../../../components/MasonryImageList';
import { GalleryImage } from '../../../../types/galleryImage';
import { displayErrorToast } from '../../../../utils/toasts';
import { useNavigate, useLocation } from "react-router-dom";
import { getGuitarServiceGallery } from '../../../../services/GuitarServiceGalleriesServiceProvider';
import LoaderSpinner from '../../../../components/LoaderSpinner';
import { SetButtonCallbackFunction } from '../../../../types/callback';
import { SEO } from '../../../../components/SEO';
import { MetaTag } from '../../../../services/SEOServiceProvider';
import aboutPage from '../../../../assets/img/about_page.jpg';

export default function GuitarServiceDetails({ props, setPageName, imageSize, metaTags }: { props: PageProps, setPageName: SetButtonCallbackFunction, imageSize: string, metaTags: MetaTag[] }) {
    const location = useLocation();
    const { state } = location;
    const { slug } = useParams();
    const navigate = useNavigate();
    const language = props.language;
    const [loading, setLoading] = React.useState('images' in state ? true : false);
    const [data, setData] = React.useState<GalleryImage[]>();
    const [metaTag, setMetaTag] = React.useState<MetaTag>();

    React.useEffect(() => {
        setPageName('guitar-service-details');
        let metaTagData = metaTags !== undefined && metaTags.filter((item: MetaTag) => item.page === 'guitar-service-details' );
        if(metaTagData && metaTagData.length > 0) {
            let guitarServiceDetailsPageMetaTag: MetaTag = {...metaTagData[0]} as MetaTag;
            guitarServiceDetailsPageMetaTag.url = window.location.href;
            guitarServiceDetailsPageMetaTag.image = aboutPage;
            setMetaTag(guitarServiceDetailsPageMetaTag);
        }

        (async () => {
            try {
                if(!('images' in state)) {
                    const guitarServiceData = await getGuitarServiceGallery(slug !== undefined ? slug : '', imageSize);
                    console.log(guitarServiceData);
                    setData(guitarServiceData.guitar_service_gallery_images);
                    if(metaTagData && metaTagData.length > 0) {
                        let guitarServiceDetailsPageMetaTag: MetaTag = {...metaTagData[0]} as MetaTag;
                        guitarServiceDetailsPageMetaTag.url = window.location.href;
                        guitarServiceDetailsPageMetaTag.image = aboutPage;
                        guitarServiceDetailsPageMetaTag.title = guitarServiceData.title.value;
                        setMetaTag(guitarServiceDetailsPageMetaTag);
                    }
                } else {
                    console.log('setting data from state');
                    setData(state.images);
                    if(metaTagData && metaTagData.length > 0) {
                        let guitarServiceDetailsPageMetaTag: MetaTag = {...metaTagData[0]} as MetaTag;
                        guitarServiceDetailsPageMetaTag.url = window.location.href;
                        guitarServiceDetailsPageMetaTag.image = aboutPage;
                        guitarServiceDetailsPageMetaTag.title = state.title.value;
                        setMetaTag(guitarServiceDetailsPageMetaTag);
                    }
                }
            } catch(error) {
                displayErrorToast(error);
            } finally {
                console.log(state.images);
                setLoading(false);
            }
        })();
    }, [language, state, slug, setPageName, imageSize, metaTags]);

    const handleBackClick = () => {
        navigate('/guitar-service');
    };

    return loading ? (
        <div>
            <SEO metaTag={metaTag} />
            <LoaderSpinner loading={loading} />
        </div>
    ) : (
        <Box>
            <SEO metaTag={metaTag} />
            <MasonryImageList images={data} clickBack={handleBackClick} />
            <Footer {...props} />
        </Box>
    );
}